import React from 'react';
import styled from 'styled-components';

interface BubbleCounterInnerProps {
  isSelected?: boolean;
  isInline?: boolean;
}

interface BubbleCounterProps extends BubbleCounterInnerProps {
  value: string;
  testId?: string;
}

export const BubbleCounter = ({
  value,
  isSelected = true,
  isInline = false,
  testId,
}: BubbleCounterProps) => {
  return (
    <BubbleCounterWrapper isInline={isInline} tabIndex={0}>
      <BubbleCounterInner isSelected={isSelected} data-test-id={testId}>
        {value}
      </BubbleCounterInner>
    </BubbleCounterWrapper>
  );
};

const getColor = ({ isSelected, theme }: any): string =>
  isSelected ? theme?.colors?.blueMain : theme?.colors?.primerGrey;

const BubbleCounterWrapper = styled.div<BubbleCounterInnerProps>`
  display: ${({ isInline }) => (isInline ? 'inline-block' : 'flex')};
  margin: ${({ isInline }) => (isInline ? '0 0.3rem' : '')};
`;

const BubbleCounterInner = styled.div<BubbleCounterInnerProps>`
  box-sizing: border-box;
  font-size: 12px;
  letter-spacing: 0.88px;
  line-height: 17px;
  min-width: 24px;
  height: 24px;
  color: #fff;
  background-color: ${getColor};
  font-family: 'Open Sans', sans-serif;
  border: 1px solid ${getColor};
  border-radius: 1.5em;
  padding: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
